<template>
  <router-view></router-view>
  <NotifyMessage @mouseenter="$store.dispatch('pauseNotifyTimer')" @mouseleave="$store.dispatch('resumeNotifyTimer')"
    @closeNotifyMessageBox="$store.dispatch('closeNotifyMessageBox')" :className="$store.state.notifyMessageClass"
    :notifyMessageContent="$store.state.notifyMessageContent" v-if="$store.state.notifyMessageShow" />
</template>

<script>
export default {
  name: "App",
  created() {

  },
};
</script>

<style lang='scss'>
@import "./assets/sass/app.scss";
</style>
